import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/Layout'

Vue.use(Router)

export default new Router({
  routes: [
    /**
     * 登录页面
     */
    {
      path: '/login',
      component: () => import('@/views/login'),
      meta: {isMenu: false}
    },
    /**
     * 404页面
     */
    {
      path: '/404',
      component: () => import('@/views/404'),
      meta: {isMenu: false}
    },
    /**
     * 首页、概况页面
     */
    {
      path: '/',
      redirect: '/dashboard',
      meta: {isMenu: false}
    },
    {
      path: '/dashboard',
      name: "首页概况",
      redirect: '/dashboard/index',
      component: Layout,
      meta: {icon: 'el-icon-house', isMenu: true},
      children: [
        {
          path: 'index',
          name: "学习概况",
          component: () => import('@/views/dashboard'),
          meta: {isMenu: true}
        }
      ]
    },
    /**
     * 新闻资讯
     */
    {
      path: '/news',
      name: "首页图片",
      redirect: '/news/news',
      component: Layout,
      meta: {icon: 'el-icon-user', isMenu: true},
      children: [
        {
          path: 'news',
          name: "图片管理",
          redirect: '/news/news/list',
          component: () => import('@/views/news/news'),
          meta: {isMenu: true},
          children: [
            {
              path: 'list',
              name: "图片列表",
              component: () => import('@/views/news/news/list'),
              meta: {isMenu: false}
            },
            {
              path: 'add',
              name: "添加图片",
              component: () => import('@/views/news/news/add'),
              meta: {isMenu: false}
            },
            {
              path: 'edit',
              name: "编辑图片",
              component: () => import('@/views/news/news/edit'),
              meta: {isMenu: false}
            }
          ]
        }
      ]
    },

    /**
     * 学习管理(视频课程+试题管理)
     */
    {
      path: '/study',
      name: "学习管理",
      redirect: '/study/video/course',
      component: Layout,
      meta: {icon: 'el-icon-video-camera', isMenu: true},
      children: [
        {
          path: 'category',
          name: "大纲分类",
          redirect: '/study/category/list',
          component: () => import('@/views/study/category'),
          meta: {isMenu: true},
          children: [
            {
              path: 'list',
              name: "分类列表",
              component: () => import('@/views/study/category/list'),
              meta: {isMenu: false}
            },
            {
              path: 'add',
              name: "添加分类",
              component: () => import('@/views/study/category/add'),
              meta: {isMenu: false}
            },
            {
              path: 'edit',
              name: "编辑分类",
              component: () => import('@/views/study/category/edit'),
              meta: {isMenu: false}
            }
          ]
        },
        {
          path: 'video/course',
          name: "视频课程",
          redirect: '/study/video/course/list',
          component: () => import('@/views/study/video/course'),
          meta: {isMenu: true},
          children: [
            {
              path: 'list',
              name: "视频课程列表",
              component: () => import('@/views/study/video/course/list'),
              meta: {isMenu: false}
            },
            {
              path: 'add',
              name: "添加视频课程",
              component: () => import('@/views/study/video/course/add'),
              meta: {isMenu: false}
            },
            {
              path: 'edit',
              name: "编辑视频课程",
              component: () => import('@/views/study/video/course/edit'),
              meta: {isMenu: false}
            }
          ]
        },
        {
          path: 'video/item',
          name: "课程视频",
          redirect: '/study/video/item/list',
          component: () => import('@/views/study/video/item'),
          meta: {isMenu: false},
          children: [
            {
              path: 'list',
              name: "视频列表",
              component: () => import('@/views/study/video/item/list'),
              meta: {isMenu: false}
            },
            {
              path: 'add',
              name: '添加视频',
              component: () => import('@/views/study/video/item/add'),
              meta: {isMenu: false}
            },
            {
              path: 'edit',
              name: '编辑视频',
              component: () => import('@/views/study/video/item/edit'),
              meta: {isMenu: false}
            }
          ]
        },
        {
          path: 'questions/paper',
          name: "试题专辑",
          redirect: '/study/questions/paper/list',
          component: () => import('@/views/study/questions/paper'),
          meta: {isMenu: true},
          children: [
            {
              path: 'list',
              name: "试题专辑列表",
              component: () => import('@/views/study/questions/paper/list'),
              meta: {isMenu: false}
            },
            {
              path: 'add',
              name: "添加试题专辑",
              component: () => import('@/views/study/questions/paper/add'),
              meta: {isMenu: false}
            },
            {
              path: 'edit',
              name: "编辑试题专辑",
              component: () => import('@/views/study/questions/paper/edit'),
              meta: {isMenu: false}
            }
          ]
        },
        {
          path: 'questions/item',
          name: "试题专辑题目",
          redirect: '/study/questions/item/list',
          component: () => import('@/views/study/questions/item'),
          meta: {isMenu: false},
          children: [
            {
              path: 'list',
              name: "试题专辑题目列表",
              component: () => import('@/views/study/questions/item/list'),
              meta: {isMenu: false}
            },
            {
              path: 'add',
              name: '添加试题专辑题目',
              component: () => import('@/views/study/questions/item/add'),
              meta: {isMenu: false}
            },
            {
              path: 'adds',
              name: '导入试题专辑题目',
              component: () => import('@/views/study/questions/item/adds'),
              meta: {isMenu: false}
            },
            {
              path: 'edit',
              name: '编辑试题专辑题目',
              component: () => import('@/views/study/questions/item/edit'),
              meta: {isMenu: false}
            }
          ]
        }
      ]
    },
    /**
     * 学生信息管理
     */
    {
      path: '/class',
      name: "学员管理",
      redirect: '/class/online',
      component: Layout,
      meta: {icon: 'el-icon-tickets', isMenu: true},
      children: [
        {
          path: 'online',
          name: "班级管理",
          redirect: '/class/online/list',
          component: () => import('@/views/class/online'),
          meta: {isMenu: true},
          children: [
            {
              path: 'list',
              name: "班级列表",
              component: () => import('@/views/class/online/list'),
              meta: {isMenu: false}
            },
            {
              path: 'add',
              name: "添加班级",
              component: () => import('@/views/class/online/add'),
              meta: {isMenu: false}
            },
            {
              path: 'edit',
              name: "编辑班级",
              component: () => import('@/views/class/online/edit'),
              meta: {isMenu: false}
            },
            {
              path: 'class_info',
              name: "班级汇总",
              component: () => import('@/views/class/online/class_info'),
              meta: {isMenu: false}
            },
            {
              path: 'student_list',
              name: "班级学员",
              component: () => import('@/views/class/online/student_list'),
              meta: {isMenu: false}
            },
            {
              path: 'student_add',
              name: "添加学员",
              component: () => import('@/views/class/online/student_add'),
              meta: {isMenu: false}
            },
            {
              path: 'student_edit',
              name: "编辑学员",
              component: () => import('@/views/class/online/student_edit'),
              meta: {isMenu: false}
            },
            {
              path: 'study_record',
              name: "学习记录",
              component: () => import('@/views/class/online/study_record'),
              meta: {isMenu: false}
            },
            {
              path: 'exam_record',
              name: "考试记录",
              component: () => import('@/views/class/online/exam_record'),
              meta: {isMenu: false}
            },
            {
              path: 'student_record',
              name: "学生记录",
              component: () => import('@/views/class/online/student_record'),
              meta: {isMenu: false}
            }
          ]
        },
        {
          path: 'member',
          name: "会员管理",
          redirect: '/class/member/list',
          component: () => import('@/views/class/member'),
          meta: {isMenu: true},
          children: [
            {
              path: 'list',
              name: "会员列表",
              component: () => import('@/views/class/member/list'),
              meta: {isMenu: false}
            },
            {
              path: 'edit',
              name: "编辑会员",
              component: () => import('@/views/class/member/edit'),
              meta: {isMenu: false}
            },
            {
              path: 'info',
              name: "会员详情",
              component: () => import('@/views/class/member/info'),
              meta: {isMenu: false}
            },
            {
              path: 'referrer',
              name: "推荐会员",
              component: () => import('@/views/class/member/referrer'),
              meta: {isMenu: false}
            }
          ]
        }
      ]
    },

    /**
     * 权限管理
     */
    {
      path: '/auth',
      name: '设置',
      redirect: '/auth/user',
      component: Layout,
      meta: {icon: 'el-icon-setting', isMenu: true},
      children: [
        {
          path: 'user',
          name: '用户管理',
          redirect: '/auth/user/list',
          component: () => import('@/views/auth/user'),
          meta: {isMenu: true},
          children: [
            {
              path: 'list',
              name: "用户列表",
              component: () => import('@/views/auth/user/list'),
              meta: {isMenu: false}
            },
            {
              path: 'add',
              name: "添加用户",
              component: () => import('@/views/auth/user/add'),
              meta: {isMenu: false}
            },
            {
              path: 'edit',
              name: "编辑用户",
              component: () => import('@/views/auth/user/edit'),
              meta: {isMenu: false}
            },
            {
              path: 'info',
              name: "用户信息",
              component: () => import('@/views/auth/user/info'),
              meta: {isMenu: false}
            },
            {
              path: 'groups',
              name: "绑定角色",
              component: () => import('@/views/auth/user/groups'),
              meta: {isMenu: false}
            },
            {
              path: 'changepassword',
              name: "修改密码",
              component: () => import('@/views/auth/user/changepassword'),
              meta: {isMenu: false}
            }
          ]
        },
        {
          path: 'role',
          name: '角色管理',
          redirect: '/auth/role/list',
          component: () => import('@/views/auth/role'),
          meta: {isMenu: true},
          children: [
            {
              path: 'list',
              name: "角色列表",
              component: () => import('@/views/auth/role/list'),
              meta: {isMenu: false}
            },
            {
              path: 'add',
              name: "添加角色",
              component: () => import('@/views/auth/role/add'),
              meta: {isMenu: false}
            },
            {
              path: 'edit',
              name: "编辑角色",
              component: () => import('@/views/auth/role/edit'),
              meta: {isMenu: false}
            }
          ]
        },
        {
          path: 'menu',
          name: '菜单管理',
          redirect: '/auth/menu/list',
          component: () => import('@/views/auth/menu'),
          meta: {isMenu: true},
          children: [
            {
              path: 'list',
              name: "菜单列表",
              component: () => import('@/views/auth/menu/list'),
              meta: {isMenu: false}
            },
            {
              path: 'add',
              name: "添加菜单",
              component: () => import('@/views/auth/menu/add'),
              meta: {isMenu: false}
            },
            {
              path: 'edit',
              name: "编辑菜单",
              component: () => import('@/views/auth/menu/edit'),
              meta: {isMenu: false}
            }
          ]
        },
        {
          path: 'api',
          name: '接口管理',
          redirect: '/auth/api/list',
          component: () => import('@/views/auth/api'),
          meta: {isMenu: true},
          children: [
            {
              path: 'list',
              name: "接口列表",
              component: () => import('@/views/auth/api/list'),
              meta: {isMenu: false}
            },
            {
              path: 'add',
              name: "添加接口",
              component: () => import('@/views/auth/api/add'),
              meta: {isMenu: false}
            },
            {
              path: 'edit',
              name: "接口角色",
              component: () => import('@/views/auth/api/edit'),
              meta: {isMenu: false}
            }
          ]
        }
      ]
    },
    /**
     * 错误页面
     */
    {
      path: '*',
      redirect: '/404',
      meta: {isMenu: false}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js